import image from '../images/loading.jpg';

function LoadingCard() {
   return[
    {
        "media": {
            "relations": {
                "nodes": [
                    {
                        "episodes": null,
                        "popularity": 10345,
                        "averageScore": 79,
                        "genres": [
                            "Action",
                            "Adventure",
                            "Comedy"
                        ],
                        "isAdult": false,
                        "coverImage": {
                            "extraLarge": image
                        },
                        "title": {
                            "romaji": "Holo no Graffiti"
                        },
                        "seasonYear": 2019
                    }
                ]
            },
            "externalLinks": [
                {
                    "site": "YouTube",
                    "url": "https://www.youtube.com/playlist?list=PLZ34fLWik_iASrR26p_41rirqp8GkPAr_",
                    "icon": "https://s4.anilist.co/file/anilistcdn/link/icon/13-ZwR1Xwgtyrwa.png"
                },
                {
                    "site": "TikTok",
                    "url": "https://www.tiktok.com/@tsunomakiwatame_hololive",
                    "icon": "https://s4.anilist.co/file/anilistcdn/link/icon/196-o2g5cLUG6k5V.png"
                }
            ],
            
            "nextAiringEpisode": {
                "airingAt": 1694772000
            },
            "description": "A series of comedic YouTube shorts airing every Friday on Watame's YouTube channel.<br><br>\n<i>Notes:<br>\n- Episodes 1-21 (Series 1) were originally released in a vertical format, later rereleased widescreen in 8 compilation videos.<br>\n- Contains special episode \"Best Girl？！スペシャル回！！！\"</i>",
            "isAdult": false,
            "title": {
                "romaji": "Loading"
            },
            "genres": [
                "Loading"
            ],
            "coverImage": {
                "extraLarge": image
            },
            "popularity": "Loading",
            "averageScore": null,
        },
        "episode": "Loading"
    },
    {
        "media": {
            "isAdult": false,
            "title": {
                "romaji": "Loading"
            },
            "genres": [
                "Loading"
            ],
            "coverImage": {
                "extraLarge": image
            },
            "popularity": "Loading",
            "averageScore": null,
        },
        "episode": "Loading"
    },
    {
        "media": {
            "isAdult": false,
            "title": {
                "romaji": "Loading"
            },
            "genres": [
                "Loading"
            ],
            "coverImage": {
                "extraLarge": image
            },
            "popularity": "Loading",
            "averageScore": null,
        },
        "episode": "Loading"
    },
    {
        "media": {
            "isAdult": false,
            "title": {
                "romaji": "Loading"
            },
            "genres": [
                "Loading"
            ],
            "coverImage": {
                "extraLarge": image
            },
            "popularity": "Loading",
            "averageScore": null,
        },
        "episode": "Loading"
    },
    {
        "media": {
            "isAdult": false,
            "title": {
                "romaji": "Loading"
            },
            "genres": [
                "Loading"
            ],
            "coverImage": {
                "extraLarge": image
            },
            "popularity": "Loading",
            "averageScore": null,
        },
        "episode": "Loading"
    },
    {
        "media": {
            "isAdult": false,
            "title": {
                "romaji": "Loading"
            },
            "genres": [
                "Loading"
            ],
            "coverImage": {
                "extraLarge": image
            },
            "popularity": "Loading",
            "averageScore": null,
        },
        "episode": "Loading"
    }
]
}

export default LoadingCard;
